import React from "react";
import "./footer.css";

let Footer = () => {
  return <footer></footer>;
};

export default Footer;
